import React from 'react';
import { allResources } from '../data/resources';
import { packComposition } from '../data/pendingContent';
import { siteConfig } from '../data/siteConfig';
import { CoverPending } from './CoverPending';
export function Offer() {
  const hasCheckout = Boolean(siteConfig.checkoutUrl);
  const ctaClass = 'inline-flex w-full justify-center whitespace-nowrap rounded-full bg-berry-deep px-8 py-4 text-base font-semibold text-white shadow-soft transition-colors duration-200';
  return <section id="acquista" aria-labelledby="offer-title" className="scroll-mt-16 bg-plum-soft px-5 sm:px-8 py-16 sm:py-24" data-id="element-168" data-mp="p00c3ffjl6zd">
      <div className="max-w-5xl mx-auto" data-id="element-169" data-mp="13xauz9uilf54">
        <h2 id="offer-title" className="font-serif text-3xl sm:text-[2.6rem] leading-tight font-semibold text-plum text-center text-balance" data-id="element-170" data-mp="13uy5mbmfg2i1">
          Il tuo prossimo progetto creativo comincia qui.
        </h2>

        <div className="mt-10 sm:mt-14 grid md:grid-cols-[1.25fr_1fr] rounded-[2rem] bg-cream overflow-hidden shadow-soft" data-id="element-171" data-mp="2fe0ygl7jzsv1">
          <div className="p-6 sm:p-10" data-id="element-172" data-mp="pkqmy7dp7p8p">
            {packComposition && <div className="mb-8 overflow-hidden rounded-2xl bg-blush" data-id="element-173" data-mp="pmbio0br1e85">
                <img src={packComposition.src} alt={packComposition.alt} loading="lazy" decoding="async" className="w-full h-auto object-contain" data-id="element-174" data-mp="ui0o2kag9pcd" />
              </div>}
            <ul className="divide-y divide-ink/10" data-id="element-175" data-mp="13ki76put61v5">
              {allResources.map(r => <li key={r.id} className="flex items-center gap-4 py-3.5 first:pt-0 last:pb-0" data-id="element-176" data-mp="6tpr3s7vk9td">
                  <div className="h-16 w-16 shrink-0 rounded-xl overflow-hidden bg-blush" data-id="element-177" data-mp="bstxkb3eztg0">
                    {r.image ? <img src={r.image} alt="" loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-178" data-mp="fufkkp9nxo3x" /> : <CoverPending title={r.name} compact data-id="element-179" data-mp="kl49pxxve8zw" />}
                  </div>
                  <div className="min-w-0" data-id="element-180" data-mp="kmyw7gosi963">
                    <p className="text-xs font-semibold text-berry-deep" data-id="element-181" data-mp="3k9fag2z636oe">{r.label}</p>
                    <p className="font-serif text-base sm:text-lg font-semibold text-plum leading-snug" data-id="element-182" data-mp="3o9pevb7b9p15">
                      {r.name}
                    </p>
                  </div>
                </li>)}
            </ul>
          </div>

          <div className="bg-blush p-8 sm:p-10 flex flex-col justify-center text-center" data-id="element-183" data-mp="qg4jtsn6twje">
            <p className="text-sm font-medium text-ink/75" data-id="element-184" data-mp="1548t660covpi">Guida pratica + raccolta di cartamodelli + 4 bonus</p>
            <p className="mt-2 font-serif text-6xl sm:text-7xl font-semibold text-plum" data-id="element-185" data-mp="106z62x0fow4u">
              {siteConfig.price}
            </p>
            <p className="mt-3 text-sm text-ink/75" data-id="element-186" data-mp="7hryz9mwyy7z">Pagamento unico · Nessun abbonamento</p>

            <div className="mt-8" data-id="element-187" data-mp="7k4l7yzpfuqu">
              {hasCheckout ? <a href={siteConfig.checkoutUrl} className={`${ctaClass} hover:bg-berry-darker`} data-id="element-188" data-mp="lich03l08q0f">
                  Acquista il pack — {siteConfig.price}
                </a> : <button type="button" disabled className={`${ctaClass} opacity-60 cursor-not-allowed`} data-id="element-189" data-mp="1wwg89207k01s">
                  Acquista il pack — {siteConfig.price}
                </button>}
            </div>

            <p className="mt-5 text-[13px] leading-relaxed text-ink/70" data-id="element-190" data-mp="20ex6txk71lsg">
              Ricevi risorse digitali in italiano. Nessun libro stampato, materiale o prodotto fisico viene spedito.
            </p>
          </div>
        </div>
      </div>
    </section>;
}